module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users-balance-modal"
  }, [_c('div', {
    staticClass: "users-balance-modal__panel"
  }, [_c('div', {
    staticClass: "users-balance-modal__header"
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.locale.t('label_balance_history')))]), _vm._v(" "), (_vm.selectedBalanceUser) ? _c('p', [_vm._v("\n          " + _vm._s(_vm.selectedBalanceUser.name) + " " + _vm._s(_vm.selectedBalanceUser.surname) + " |\n          "), _c('b', {
    class: _vm.getBalanceClass(_vm.selectedBalanceUser.barBalance)
  }, [_vm._v(_vm._s(_vm.formatBalanceAmount(_vm.selectedBalanceUser.barBalance)))])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "new-button users-balance-btn users-balance-btn--close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_close')))])]), _vm._v(" "), _c('div', {
    staticClass: "users-balance-modal__adjust"
  }, [_c('h4', [_vm._v(_vm._s(_vm.locale.t('label_balance_adjustment')))]), _vm._v(" "), _c('div', {
    staticClass: "users-balance-modal__adjust-grid"
  }, [_c('input', {
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": _vm.locale.t('label_amount')
    },
    domProps: {
      "value": _vm.balanceAdjustAmount
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update-amount', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('textarea', {
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.locale.t('label_note'),
      "rows": "2"
    },
    domProps: {
      "value": _vm.balanceAdjustNote
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update-note', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "users-balance-modal__actions"
  }, [_c('button', {
    staticClass: "new-button users-balance-btn users-balance-btn--add",
    attrs: {
      "disabled": _vm.isAdjustingBalance
    },
    on: {
      "click": function($event) {
        return _vm.$emit('submit-adjust', 'credit')
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_balance_add')) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "new-button users-balance-btn users-balance-btn--subtract",
    attrs: {
      "disabled": _vm.isAdjustingBalance
    },
    on: {
      "click": function($event) {
        return _vm.$emit('submit-adjust', 'debit')
      }
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_balance_subtract')) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "users-balance-modal__history"
  }, [_c('h4', [_vm._v(_vm._s(_vm.locale.t('label_history')))]), _vm._v(" "), (_vm.isLoadingBalanceHistory) ? _c('div', {
    staticClass: "users-balance-modal__loading"
  }, [_vm._v(_vm._s(_vm.locale.t('label_loading')))]) : _c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.locale.t('label_date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_source')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_amount')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_before')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_after')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_note')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.balanceHistory), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_date')
      }
    }, [_vm._v(_vm._s(_vm.formatBalanceTimestamp(item.createdTimestamp)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_type')
      }
    }, [_vm._v(_vm._s(_vm.mapBalanceChangeType(item.changeType)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_source')
      }
    }, [_vm._v(_vm._s(_vm.mapBalanceSourceType(item.sourceType)))]), _vm._v(" "), _c('td', {
      class: _vm.getBalanceClass(item.amount),
      attrs: {
        "data-title": _vm.locale.t('label_amount')
      }
    }, [_vm._v(_vm._s(_vm.formatBalanceAmount(item.amount)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_before')
      }
    }, [_vm._v(_vm._s(_vm.formatBalanceAmount(item.balanceBefore)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_after')
      }
    }, [_vm._v(_vm._s(_vm.formatBalanceAmount(item.balanceAfter)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_note')
      }
    }, [_vm._v(_vm._s(item.note != null && item.note.length > 0 ? item.note : '/'))])])
  }), _vm._v(" "), (_vm.balanceHistory.length === 0) ? _c('tr', {
    staticClass: "users-balance-empty-row"
  }, [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_no_data')))])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "users-balance-modal__pager"
  }, [_c('button', {
    staticClass: "new-button users-balance-pager-btn",
    attrs: {
      "disabled": _vm.balanceHistoryPage <= 1 || _vm.isLoadingBalanceHistory
    },
    on: {
      "click": function($event) {
        return _vm.$emit('load-history', _vm.balanceHistoryPage - 1)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.locale.t('label_pagination_previous')) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "users-balance-modal__page-indicator"
  }, [_vm._v(_vm._s(_vm.balanceHistoryPage))]), _vm._v(" "), _c('button', {
    staticClass: "new-button users-balance-pager-btn",
    attrs: {
      "disabled": (_vm.balanceHistoryPage * _vm.balanceHistoryLimit) >= _vm.balanceHistoryTotal || _vm.isLoadingBalanceHistory
    },
    on: {
      "click": function($event) {
        return _vm.$emit('load-history', _vm.balanceHistoryPage + 1)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.locale.t('label_pagination_next')) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e8e59a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/UserBalanceHistoryModal.vue
// module id = 822
// module chunks = 0